import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Subscription as RxSubscription } from 'rxjs';
import { OrderApiService } from 'src/modules/order/services/order-api-service';
import { OrderDataSource } from 'src/modules/order/services/order-data-source';
import { IProduct } from '../../interfaces/product';
import { IProductListConfig } from '../../interfaces/productListconfig';
import { ProductDataSource } from '../../services/product-data-source';
import { ProductOrderList } from '../productList/component';
import { ProductEdit } from '../edit/component';

@Component({
    selector: 'product-list-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class ProductList implements OnInit, OnDestroy {
  public displayedColumns = [
    'title',
    'ticketsAvailable',
    'ticketsSold',
    'actions',
  ];
  public loading: boolean;
  public hasProducts: boolean;
  public listingTitle: string;
  public listingId: string;
  protected DataSource: ProductDataSource;
  private Subscriptions: RxSubscription[] = [];
  public data: IProduct[];

  constructor(
    protected Dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data: IProductListConfig,
    private ProductDataSource: ProductDataSource,
    protected OrderApi: OrderApiService
  ) {
    this.DataSource = ProductDataSource;
    this.listingId = data.listingId;
    this.listingTitle = data.listingTitle;
  }

  async ngOnInit() {
    this.DataSource.connect().value;

    this.Subscriptions.push(
      this.DataSource.loading.subscribe((loading) => (this.loading = loading))
    );
    await this.DataSource.load(this.listingId);
    this.Subscriptions.push(
      this.DataSource.Product.subscribe(
        (products) => (this.hasProducts = !!products['data'].length)
      )
    );

    this.data = this.DataSource.Product.value['data'];
  }

  ngOnDestroy() {
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }

  editProduct(Product?) {
    const config = new MatDialogConfig();

    const { listingTitle: eventTitle } = this;

    config.disableClose = true;
    config.data = {
      DataSource: this.DataSource,
      eventTitle,
      Product,
    };

    this.Dialog.open(ProductEdit, config)
      .afterClosed()
      .subscribe((updated) => updated && this.ngOnInit());
  }

  deleteItem(Product: IProduct) {
    const title = `${this.listingTitle} | ${Product.title}`;
    confirm(`Are you sure you want to delete: ${title}`) &&
      this.DataSource.delete(Product.id).then(() => this.ngOnInit());
  }

  listOrders(Product) {
    const { listingTitle } = this;
    const config = new MatDialogConfig();
    config.disableClose = true;

    const DataSource = new OrderDataSource(this.OrderApi);

    const title = listingTitle;
    const Item = Product;

    config.data = {
      DataSource,
      Item,
      title,
    };

    this.Dialog.open(ProductOrderList, config).afterClosed().subscribe();
  }
}
